import { RbcCircleRec, RbcStatus } from '@calm/evexia-web-sdk';
import { routes } from '../routes';

export const isRecommended = (recommendation?: RbcCircleRec) =>
    [RbcStatus.Created, RbcStatus.Viewed, RbcStatus.InProgress].includes(
        recommendation?.status ?? RbcStatus.Removed
    );

export const sortRecommendations = (a?: RbcCircleRec, b?: RbcCircleRec) =>
    (a?.order ?? Number.MAX_SAFE_INTEGER) -
    (b?.order ?? Number.MAX_SAFE_INTEGER);

export const getTrackReferralLocation = (pathName: string) => {
    if (pathName === routes.careplan) {
        return 'care_plan';
    } else if (pathName === routes.dashboard) {
        return 'home';
    } else if (
        pathName === routes.standaloneResults ||
        pathName === routes.results({ isFtue: false })
    ) {
        return 'mental_health_survey_results';
    }
    return 'mental_health_survey_results';
};
